import { Grid } from '@mui/material';
import 'flatpickr/dist/l10n/es';
import 'flatpickr/dist/themes/material_green.css';
import React from 'react';
import Flatpickr from 'react-flatpickr';

import { GridSizeType, gridSize } from '@/shared/constants';

export type RangePickerPlanificadorProps = {
  onChange: (selectedDates: Date[]) => void;

  flatpickrRef: React.MutableRefObject<Flatpickr | null>;
  minDate?: Date;
  maxDate?: Date;

  gridSizeContainer?: GridSizeType;
};

const RangePickerPlanificador: React.FC<RangePickerPlanificadorProps> = ({
  flatpickrRef,
  onChange,
  minDate,
  maxDate,
  gridSizeContainer = gridSize,
}) => {
  return (
    <>
      <Grid item {...gridSizeContainer}>
        <div style={{ maxWidth: '100%' }}>
          <Flatpickr
            ref={flatpickrRef}
            placeholder="Seleccionar Rango de Fecha"
            options={{
              mode: 'range',
              dateFormat: 'Y-m-d',
              // min date ----
              minDate,
              maxDate,
              // ----
              locale: {
                firstDayOfWeek: 1,
                weekdays: {
                  shorthand: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
                  longhand: [
                    'Domingo',
                    'Lunes',
                    'Martes',
                    'Miércoles',
                    'Jueves',
                    'Viernes',
                    'Sábado',
                  ],
                },
                months: {
                  shorthand: [
                    'Ene',
                    'Feb',
                    'Mar',
                    'Abr',
                    'May',
                    'Jun',
                    'Jul',
                    'Ago',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dic',
                  ],
                  longhand: [
                    'Enero',
                    'Febrero',
                    'Marzo',
                    'Abril',
                    'Mayo',
                    'Junio',
                    'Julio',
                    'Agosto',
                    'Septiembre',
                    'Octubre',
                    'Noviembre',
                    'Diciembre',
                  ],
                },
              },
              onChange: e => onChange(e),
            }}
            style={{
              width: '100%',
              padding: '16.5px 14px',
              border: '1px solid #ccc',
              borderRadius: '9px',
              font: 'inherit',
              fontSize: '14px',
            }}
          />
        </div>
      </Grid>
    </>
  );
};

export default RangePickerPlanificador;
